import RawBtn from './rawBtn.js'

import styles from '../styles/leftChev.js'
import icoChevLeft from '../images/icon-chev-left.svg'


export default ({ children, classNames, ...props }) => (
	<RawBtn classNames={[ styles.leftChev, classNames ]} {...props}>
		<div className={styles.content}>
			<img src={icoChevLeft}/>
			{children}
		</div>
	</RawBtn>
)
